/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import {
    tableContext,
    tableFiledFacetSelector,
    tableFiledFilterSelector,
    tableMetaFilterSelector,
    tableMetaUrlSelector,
} from '../../../selectors';

export const useTableFilter = (fieldName: string) => {

    const meta = useSelector(tableMetaUrlSelector);
    const context = useSelector(tableContext);

    const facetsSelector = useMemo(() => tableFiledFacetSelector(meta, fieldName, context), [meta, fieldName, context]);
    const facets = useSelector(facetsSelector);

    const filterSelector = useMemo(() => tableMetaFilterSelector(meta, undefined, context), [context, meta]);
    const filters = useSelector(filterSelector);

    const selectedFilter = useSelector(tableFiledFilterSelector(meta, fieldName, context));

    return { facets, filters, selectedFilter };
};
